import { ICartPayload, ICartResponse } from 'src/app/common/payment/models/cart.model';
import { IContribute } from 'src/app/common/payment/models/contribute.model';
import { IOrder, IOrderPayload } from 'src/app/common/payment/models/order.model';
import { IUser } from './user.model';

export interface IPayConfig {
  amount: number;
  cartAmount: number;
  sipAmount: number;
  sipCartAmount: number;
  currency: string;
  isSip: boolean;
  disableAction: boolean;
  loading: boolean;
  donateBtnLabel: string;
  tipAmount: number;
  tipPerc: number;
  sipTipAmount: number;
  SipTipPerc: number;
  gCaptchaToken: string;
  userData?: IUser;
  cartPayload?: ICartPayload;
  cartResponse?: ICartResponse;
  sipCartResponse?: ICartResponse;
  contributeResponse?: IContribute;
  contributeSipResponse?: IContribute;
  optionsResponse?: any;
  orderPayload?: IOrderPayload;
  orderResponse?: IOrder;
  sendPayoad?: any;
  sendResponse?: any;
}

export const DEFAULT_PAY_CONFIG: IPayConfig = {
  amount: 0,
  cartAmount: 0,
  sipAmount: 0,
  sipCartAmount: 0,
  currency: 'INR',
  isSip: false,
  loading: false,
  disableAction: false,
  donateBtnLabel: '',
  tipAmount: 0,
  tipPerc: 0,
  sipTipAmount: 0,
  SipTipPerc: 0,
  gCaptchaToken: ''
}

export interface ISendPayload {
  order_id: string;
  return_url: string;
  token?: string;
  token_1?: string;
  save_card?: any;
  customer_id: string;
  account_no?: string;
  ifsc_code?: string;
  bank_code?: string;
  bank_name?: string;
  auth_mode?: string;
  payment_method_change?: number | string;
  showError?: 'false';
}